module.exports = __webpack_public_path__ + "img/pic_location_YunlinCounty.5fdae117.png";